import React from 'react';
import { mod } from 'react-swipeable-views-core';
import type { SlideRendererCallback } from 'react-swipeable-views-utils';
import type { List } from 'lib/LobbyEntities';
import Builder, { type Mapping } from '../../../../../../../../../Builder';

const slideRenderer = (list: List, mapping: Mapping) => {
  const itemsTotal = list.children.length;

  const OfferSlide: SlideRendererCallback = ({ key, index }) => {
    const { __access } = list.children?.[mod(index, itemsTotal)] ?? {};
    return __access ? <Builder key={key} accessRef={__access} mapping={mapping} /> : null;
  };

  return OfferSlide;
};

export default slideRenderer;
